// AppShell — kerangka adaptif tunggal (menggantikan App.tsx monolitik).
// Desktop: sidebar kiri + konten. Mobile: konten + bottom tabs (zona
// jempol). Halaman dirender via <Outlet/> dari router.

import { Suspense } from "react";
import { Outlet } from "react-router-dom";
import { Sidebar } from "./Sidebar";
import { BottomTabs } from "./BottomTabs";
import { Topbar } from "./Topbar";
import { IdleLock } from "./IdleLock";

export function AppShell() {
  return (
    <div className="flex min-h-screen bg-bg text-ink">
      <Sidebar />
      <div className="flex min-h-screen min-w-0 flex-1 flex-col">
        <Topbar />
        <main className="flex-1 pb-24 lg:pb-0">
          {/* Tiap halaman di-lazy-load (code-split) — shell tetap terpasang
              saat chunk halaman dimuat. */}
          <Suspense fallback={<div className="p-6 text-sm text-muted">Memuat…</div>}>
            <Outlet />
          </Suspense>
        </main>
      </div>
      <BottomTabs />
      <IdleLock />
    </div>
  );
}
